// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Expertise / Skills ─────────────────────────────────── */
.skills-section {
  margin-top: 64px;
  padding: 80px 10%;
  background-color: var(--bg);
}
@media (max-width: 768px) {
  .skills-section {
    padding: 60px 5%;
  }
}

.skills-header {
  text-align: center;
  margin-bottom: 56px;
}
.skills-header h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
  color: var(--text) !important;
}

.skills-rule {
  width: 48px;
  height: 3px;
  background: var(--accent);
  border-radius: 2px;
  margin: 0 auto;
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
@media (max-width: 700px) {
  .skills-grid {
    grid-template-columns: 1fr;
  }
}

.skill-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 28px 24px;
  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;
}
.skill-card:hover {
  border-color: var(--accent);
  transform: translateY(-3px);
  box-shadow: var(--shadow);
}

.skill-card-icons {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.skill-card-icons svg {
  font-size: 1.6rem;
  color: var(--accent) !important;
  opacity: 0.85;
}

.skill-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text) !important;
  margin: 0 0 8px;
  letter-spacing: -0.3px;
}

.skill-card-desc {
  font-size: 0.825rem;
  color: var(--text-muted) !important;
  line-height: 1.6;
  margin: 0 0 18px;
}

.skill-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.skill-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 0.72rem;
  font-weight: 600;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  letter-spacing: 0.3px;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-muted) !important;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
  cursor: default;
  line-height: 1.6;
}
.skill-tag:hover {
  border-color: var(--accent);
  color: var(--accent) !important;
  background: var(--accent-soft);
}

/* Override MUI Chip to match design system */
.chip.MuiChip-root {
  height: 24px !important;
  border: 1px solid var(--border) !important;
  background: transparent !important;
  border-radius: 5px !important;
  transition: border-color 0.2s, background 0.2s !important;
}
.chip.MuiChip-root:hover {
  border-color: var(--accent) !important;
  background: var(--accent-soft) !important;
}
.chip.MuiChip-root .MuiChip-label {
  color: var(--text-muted) !important;
  font-family: "SF Mono", "Fira Code", Consolas, monospace !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  padding: 0 9px !important;
  letter-spacing: 0.3px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Expertise.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;AACE;EALF;IAK8B,gBAAA;EAG5B;AACF;;AADA;EACE,kBAAA;EACA,mBAAA;AAIF;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AAIJ;;AAAA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAGF;;AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAGF;AADE;EALF;IAK8B,0BAAA;EAK5B;AACF;;AAHA;EACE,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,8DAAA;AAMF;AAJE;EACE,2BAAA;EACA,2BAAA;EACA,yBAAA;AAMJ;;AAFA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAKF;AAHE;EACE,iBAAA;EACA,+BAAA;EACA,aAAA;AAKJ;;AADA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,sBAAA;AAIF;;AADA;EACE,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAIF;;AADA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mCAAA;EACA,0DAAA;EACA,eAAA;EACA,gBAAA;AAIF;AAFE;EACE,2BAAA;EACA,+BAAA;EACA,8BAAA;AAIJ;;AAAA,6CAAA;AACA;EACE,uBAAA;EACA,0CAAA;EACA,kCAAA;EACA,6BAAA;EACA,yDAAA;AAGF;AADE;EACE,sCAAA;EACA,yCAAA;AAGJ;AAAE;EACE,mCAAA;EACA,mEAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;EACA,qBAAA;AAEJ","sourcesContent":["/* ─── Expertise / Skills ─────────────────────────────────── */\n\n.skills-section {\n  margin-top: 64px;\n  padding: 80px 10%;\n  background-color: var(--bg);\n\n  @media (max-width: 768px) { padding: 60px 5%; }\n}\n\n.skills-header {\n  text-align: center;\n  margin-bottom: 56px;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    margin: 0 0 12px;\n    color: var(--text) !important;\n  }\n}\n\n.skills-rule {\n  width: 48px;\n  height: 3px;\n  background: var(--accent);\n  border-radius: 2px;\n  margin: 0 auto;\n}\n\n.skills-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n\n  @media (max-width: 700px) { grid-template-columns: 1fr; }\n}\n\n.skill-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 28px 24px;\n  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;\n\n  &:hover {\n    border-color: var(--accent);\n    transform: translateY(-3px);\n    box-shadow: var(--shadow);\n  }\n}\n\n.skill-card-icons {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n\n  svg {\n    font-size: 1.6rem;\n    color: var(--accent) !important;\n    opacity: 0.85;\n  }\n}\n\n.skill-card-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text) !important;\n  margin: 0 0 8px;\n  letter-spacing: -0.3px;\n}\n\n.skill-card-desc {\n  font-size: 0.825rem;\n  color: var(--text-muted) !important;\n  line-height: 1.6;\n  margin: 0 0 18px;\n}\n\n.skill-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.skill-tag {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 5px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  letter-spacing: 0.3px;\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-muted) !important;\n  transition: border-color 0.2s, color 0.2s, background 0.2s;\n  cursor: default;\n  line-height: 1.6;\n\n  &:hover {\n    border-color: var(--accent);\n    color: var(--accent) !important;\n    background: var(--accent-soft);\n  }\n}\n\n/* Override MUI Chip to match design system */\n.chip.MuiChip-root {\n  height: 24px !important;\n  border: 1px solid var(--border) !important;\n  background: transparent !important;\n  border-radius: 5px !important;\n  transition: border-color 0.2s, background 0.2s !important;\n\n  &:hover {\n    border-color: var(--accent) !important;\n    background: var(--accent-soft) !important;\n  }\n\n  .MuiChip-label {\n    color: var(--text-muted) !important;\n    font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace !important;\n    font-size: 0.72rem !important;\n    font-weight: 600 !important;\n    padding: 0 9px !important;\n    letter-spacing: 0.3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
